const CATEGORY_KEY = 'lead_treatments__treatment__treatment_item__treatment_category';
const NAME_KEY = `${CATEGORY_KEY}__name`;

// Split the grouped category rows into the legacy ring cards by the category NAME carried on
// each row (the same source as the Category Summary table), instead of mapping name -> id
// through the paginated practice-treatment list, which silently missed categories.
export const splitCategoryRows = (rows = []) => {
    const named = (name) => rows.filter((r) => r?.[NAME_KEY] === name);
    const implants = named('Implants');
    const orthodontics = named('Orthodontics');
    const cosmetic = named('Cosmetic Dentistry');
    const other = rows.filter((r) => ![implants, orthodontics, cosmetic].some((g) => g.includes(r)));
    return { implants, orthodontics, cosmetic, other };
};
